import { Controller } from "react-hook-form";

import { TextInputProps } from "../../../interfaces";
import { nameRegex, noEmojiRegex } from "utils";
import {
  erroreCampoObbligatorio,
  erroreCaratteriNonValidi,
  errorMaxLength,
} from "../../../_constants";
import { forwardRef, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";

export const TextareaInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      control,
      name,
      placeholder,
      maxLength,
      trigger,
      required = true,
      onlyLetters = true,
      focusOutFunction,
      validationRules,
      template,
      showError = true,
      noEmoji = true,
      disabled,
      onInput,
      height,
    }: TextInputProps,
    ref
  ) => {
    useEffect(() => {
      if (trigger && control._getDirty()) {
        trigger(name);
      }
    }, [trigger, control, name]);

    return (
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? erroreCampoObbligatorio : false,
          maxLength: {
            value: maxLength ?? 1024,
            message: `${errorMaxLength} ${maxLength}`,
          },
          validate: {
            onlyLetters: (value) =>
              !onlyLetters ||
              nameRegex.test(value) ||
              !value?.length ||
              erroreCaratteriNonValidi,
            noEmoji: (value) =>
              !noEmoji || !noEmojiRegex.test(value) || erroreCaratteriNonValidi,
            ...validationRules,
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <div className="flex-container height-100" style={{ height: height }}>
            <InputTextarea
              autoResize
              id={field.name}
              {...field}
              className={`${
                error && showError ? "p-invalid margin-bottom-4" : ""
              } ${template}`}
              placeholder={placeholder}
              disabled={disabled}
              onBlur={() => {
                if (!error && focusOutFunction) {
                  focusOutFunction(field.value);
                }
              }}
              onKeyDown={onInput}
            />

            {error && showError && (
              <small className="p-error margin-bottom-4">{error.message}</small>
            )}
          </div>
        )}
      />
    );
  }
);
